import icon from '@material-ui/icons/Person'

const globaldatas = { icon, options: { label: 'Globaldatas' } }

export default globaldatas
